import React, { Component } from 'react';
import { Edit } from '$components/account';
import { currentAgentSelector, formSelector } from '$selectors';
import { connect } from 'react-redux';
import { update, fetchCurrent } from '$actions/agents';
import { changeTitle } from '$actions/root';
import timeZones from '$constants/time-zones.json';
import languages from '$constants/languages.json';
import { getRoles } from '../../api';
import { Translate } from '$common';

@connect(state => ({
  agent: currentAgentSelector(state),
  form: formSelector(state, 'agentUpdate')
}), { update, fetchCurrent, changeTitle })
export default class EditRoute extends Component {

  state = {
    roles: null
  };

  async getRoles() {
    const { data: roles } = await getRoles();
    this.setState({ roles });
  }

  componentWillMount() {
    this.props.changeTitle(Translate.get('edit_profile'))
    this.getRoles();
    this.props.fetchCurrent();
  }

  render() {
    const { agent, update, form } = this.props;
    const { roles } = this.state;

    if (!agent) return <div></div>;

    return (
      <Edit
        account={agent}
        errors={form.errors}
        success={form.success}
        timeZones={timeZones}
        languages={languages}
        onSubmit={update}
        roles={roles}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/account/edit.js